import Echo from 'laravel-echo';
import axios from 'axios';
import Pusher from 'pusher-js';

  const initializeEcho =async ()  => {
    const token = localStorage.getItem('token');
   // Pusher.logToConsole = true;
    (window as any).Pusher = Pusher;

    const echo =  await new Echo({
      broadcaster: 'reverb',
      key: process.env.REACT_APP_PUSHER_APP_KEY, 
      wsHost: process.env.REACT_APP_PUSHER_HOST, 
      wsPort: process.env.REACT_APP_PUSHER_PORT, 
      wssPort: process.env.REACT_APP_PUSHER_PORT,
      forceTLS: false,
      enableStats: true,
      enabledTransports: ['ws', 'wss'],
         authorizer: (channel :any, options : any) => {
          return {
            authorize: (socketId : any, callback : any ) => {
              
              axios.post(process.env.REACT_APP_API_URL+'/broadcasting/auth', {
                socket_id: socketId,
                channel_name: channel.name
              },{
                headers: {
                "Authorization" : `Bearer ${token}` ,
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                'Access-Control-Allow-Origin': '*'}
              })
              .then(response => {
                callback(false, response.data);
              })
              .catch(error => {
                console.log("falses", error);
                callback(true, error);
              });
            }
          };
        },
  });
  return echo;
  };
  
  export default initializeEcho;